import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";
import { ClipLoader } from "react-spinners";
import "../component/css/popup.css";

const Confirm_Pin3 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  //console.log(location);
  const [disable2, setDisable2] = useState(false);
  const [pin, setPin] = useState("");
  const delivery_id = location.state.id;
  //console.log(delivery_id);
  const token = JSON.parse(sessionStorage.getItem("userToken"));

  const CheckPin = async () => {
    try {
      setDisable2(true);
      const response = await fetch(
        "https://serverpickload.wl.r.appspot.com/admin_payment_record/verify_activity_pin",
        {
          method: "POST",

          body: JSON.stringify({
            token,
            activity_pin: pin,
          }),
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json, text/plain, */*",
          },
        }
      );

      const result = await response.json();

      if (result.msg === "activity pin correct") {
        //console.log("data gotten succesfully");
        refundPayment();
      } else if (result.msg === "activity pin incorrect") {
        window.alert("Activity pin incorrect");
        setDisable2(false);
      } else {
        setDisable2(false);
        //console.log("some error occurred");
        window.alert("some error occurred");
      }
    } catch (error) {
      //console.log(error);
      window.alert("some error occurred");
    }
  };

  const refundPayment = async () => {
    try {
      const response = await fetch(
        "https://serverpickload.wl.r.appspot.com/admin_payment_record/refund_transaction",
        {
          method: "POST",

          body: JSON.stringify({
            token,
            delivery_id,
          }),
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json, text/plain, */*",
          },
        }
      );

      const result = await response.json();
      //console.log(result);

      if (result.msg === "Success") {
        setDisable2(false);
        window.alert("Refund successful");
        setTimeout(() => {
          navigate(-1);
        }, 3000);
      } else {
        //console.log("some error occurred");
        window.alert("Refund unsuccessful");
        setDisable2(false);
      }
    } catch (error) {
      setDisable2(false);
      window.alert("some error occurred");
      //console.log(error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    CheckPin();
  };

  const handleChange = (e) => {
    e.preventDefault();
    setPin(e.target.value);
  };

  return (
    <div className="chizzys-parent-container">
      <FontAwesomeIcon
        icon={faArrowLeftLong}
        className="chizzys-arrow"
        onClick={() => navigate(-1)}
      ></FontAwesomeIcon>
      <div className="logout-container">
        <div className="logout-background">
          <div className="logout-confirmation1">
            <div className="chizzy-confirmation-info">
              <br></br>
              <h4>Confirm activity pin</h4>
              <br></br>
              <br></br>
              {/* <img src={amico} width='110px' height='110px' alt='icon' /><br></br> */}
              <div className="logout-rematched">
                <p>
                  Please put in your activity pin to continue this operation
                </p>
              </div>
            </div>
            <div className="logout-dialog-row">
              <form className="chizzys-form" onSubmit={handleSubmit}>
                <input
                  type="password"
                  value={pin}
                  onChange={handleChange}
                  placeholder="Activity pin"
                />
                <button type="submit">
                  {disable2 ? (
                    <ClipLoader color={"black"} loading={disable2} size={15} />
                  ) : (
                    "Refund"
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Confirm_Pin3;
